export const isValidString = (str) => typeof str === 'string' && str.trim().length > 0;